import React from "react";
import { cn } from "../../utils/cn";
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline";
  size?: "default" | "lg" | "xl";
  fullWidth?: boolean;
}
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = "primary",
  size = "default",
  fullWidth,
  ...props
}, ref) => {
  return <button ref={ref} className={cn("inline-flex items-center justify-center rounded-full font-[900] transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase", {
    "bg-[#FFC900] text-[#07152D] hover:bg-[#e6b500] border-4 border-white/20 shadow-[0_5px_15px_rgba(0,0,0,0.15)] animate-heartbeat": variant === "primary",
    "bg-[#142FA8] text-white hover:bg-[#1737B7] hover:-translate-y-0.5 shadow-[0_4px_14px_rgba(20,47,168,0.3)]": variant === "secondary",
    "border-2 border-[#142FA8] text-[#142FA8] hover:bg-[#F5F7F9]": variant === "outline",
    "h-12 px-6 text-[14px]": size === "default",
    "h-14 px-8 text-[15px]": size === "lg",
    "h-[56px] md:h-[60px] px-10 text-[15px] md:text-[16px]": size === "xl",
    "w-full": fullWidth
  }, className)} {...props} data-id="element-289" data-mp="1nive6pttd3je" />;
});
Button.displayName = "Button";